import angular from 'angular';

export default angular.module('cms.save.warning', []).factory('SaveWarning',
    function (saveWarningDialog, gettextCatalog, $window, $interval, saveWarningIntervalDialog, $rootScope) {

        /** @ngInject() */

        const TIME_TO_WARN = 300000;

        this.editedObject = {};
        this.currentObject = {};
        let warnInterval;

        let watch = (editedObject, currentObject, contentScope = null, element = null) => {
            this.editedObject = angular.copy(editedObject);
            this.currentObject = currentObject;
            $window.onbeforeunload = onbeforeunload;
            if(contentScope && element) {
                element.on('mousedown', () => {
                    if (!angular.equals(this.editedObject, this.currentObject)) {
                        addWarningInterval();
                    }
                });

                contentScope.$on('sections-library.drop-model', () => {
                    addWarningInterval();
                });
                contentScope.$on('content-changed', () => {
                    addWarningInterval();
                });
            }
        };

        let stopWatch = () => {
            this.editedObject = {};
            this.currentObject = {};
            cancelTimeWarning();
        };

        let addWarningInterval = () => {
            if(!warnInterval) {
                warnInterval = $interval(warn, TIME_TO_WARN);
            }
        };

        let isEdited = () => {

            if (!angular.equals(this.editedObject, this.currentObject)) {

                return saveWarningDialog
                    .open()
                    .then(() => {
                        return false;
                    }).catch(() => {
                        cancelTimeWarning();
                        $window.onbeforeunload = null;
                    });
            }

            return true;
        };

        let onbeforeunload = () => {

            if (!angular.equals(this.editedObject, this.currentObject)) {
                return true;
            }
        };

        let warn = () => {
            let scroll = $(document).scrollTop();
            if (!angular.equals(this.editedObject, this.currentObject)) {
                if(!saveWarningIntervalDialog.isOpen()) {
                    saveWarningIntervalDialog
                        .open()
                        .then(() => {
                            cancelTimeWarning();
                            $(document).scrollTop(scroll);
                            $rootScope.$broadcast('save.object');
                        }).catch(() => {
                            cancelTimeWarning();
                            $(document).scrollTop(scroll);
                            return false;
                        });
                }
            }
        };

        let cancelTimeWarning = () => {
            $interval.cancel(warnInterval);
            warnInterval = null;
        };

        return {
            isEdited: isEdited,
            onbeforeunload: onbeforeunload,
            watch: watch,
            cancelTimeWarning: cancelTimeWarning,
            stopWatch: stopWatch
        };

    }).name;



// WEBPACK FOOTER //
// ./src/cmsCore/SaveWarning/SaveWarning.js